var link_preview_default = {
  "fontElementMap": "UHHlU",
  "linkPreviewContainer": "wqD10",
  "linkPreview": "_6-qtd",
  "linkPreviewImage": "IglEE",
  "linkPreviewPlaceholder": "OrP94",
  "linkPreviewInfo": "kaIW0",
  "linkPreviewTitle": "_6NBYc",
  "linkPreviewDescription": "iKq0s",
  "linkPreviewUrl": "SqPkO",
  "linkPreviewResponsiveImage": "l5Y2J",
  "loadingContainer": "_3592o",
  "errorIcon": "_44HT5",
  "errorInfo": "_1Xp90",
  "errorContainer": "OGqUJ",
  "overlay": "v2QMJ",
  "thumbnailEnd": "jh5p2",
  "thumbnailStart": "P8XYA",
  "thumbnailTop": "S-J2v"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
